import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('student');

export class StudentSubjects extends Api {
  constructor(http, config = {}) {
    super(http, url, 'studentSubjects', config);
  }
  async getStudentSubjets(search, page = 0, limit = 10, config = {}) {
    config = { ...this._config, ...config };

    return this._http.get(`${this._baseUrl}/student-subject/student-subjects?search=${search}&page=${page}&limit=${limit}`, config);
  }

  async setStatusOngoing(ids, config = {}) {
    config = { ...this._config, ...config };

    return this._http.put(`${this._baseUrl}/student-subject/student-subjects/in-progress?ids=${ids}`, null, config);
  }

  async setStatusApproved(ids, config = {}) {
    config = { ...this._config, ...config };

    return this._http.put(`${this._baseUrl}/student-subject/student-subjects/approve?ids=${ids}`, null, config);
  }

  async setStatusReproved(ids, config = {}) {
    config = { ...this._config, ...config };

    return this._http.put(`${this._baseUrl}/student-subject/student-subjects/reprove?ids=${ids}`, null, config);
  }

  async setStatusCanceled(ids, config = {}) {
    config = { ...this._config, ...config };

    return this._http.put(`${this._baseUrl}/student-subject/student-subjects/cancel?ids=${ids}`, null, config);
  }

  async setStatusPending(ids, config = {}) {
    config = { ...this._config, ...config };

    return this._http.put(`${this._baseUrl}/student-subject/student-subjects/pending?ids=${ids}`, null, config);
  }

  async updateStudentSubjectGrade(requestBody, id, config = {}) {
    config = { ...this._config, ...config };
    return this._http.put(`${this._baseUrl}/student-subject/student-subjects/${id}/update-grade`, requestBody, config);
  }

}
